import { Suspense, type ReactNode } from "react";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { QueryProvider } from "./QueryProvider";
import { router } from "@/router";
import { Spinner } from "@/components/ui/Spinner";

function PageLoader() {
  return (
    <div className="flex h-screen items-center justify-center bg-surface-muted">
      <Spinner size="lg" />
    </div>
  );
}

interface Props { children?: ReactNode }

export function AppProviders(_: Props) {
  return (
    <QueryProvider>
      <Suspense fallback={<PageLoader />}>
        <RouterProvider router={router} />
      </Suspense>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            fontFamily: "Inter, sans-serif",
            fontSize: "0.875rem",
            borderRadius: "0.5rem",
            boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.08)",
          },
          success: { iconTheme: { primary: "#22c55e", secondary: "#fff" } },
          error:   { iconTheme: { primary: "#ef4444", secondary: "#fff" } },
        }}
      />
    </QueryProvider>
  );
}
